import { Button, makeStyles } from '@material-ui/core';
import React, { useCallback } from 'react';
import DesktopAlertSVG from './DesktopAlertSVG';

const useStyles = makeStyles((theme) => ({
  desktopAlertWrapper: {
    backgroundColor: '#232323CC',
    color: '#fff',
    padding: '10px',
    borderRadius: '5px',
    margin: '10px',
    height: '100%',
    width: '100%',
    position: 'fixed',
    top: 0,
    left: ' -10px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 10,
  },
  desktopAlertContent: {
    minWidth: '200px',
    width: '90%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#fff',
    color: '#000',
    borderRadius: '5px',
    padding: '10px',
    flexDirection: 'column',
    padding: '40px 20px',
  },
  message: {
    fontFamily: 'IBM Plex Sans',
    fontWeight: 500,
    fontSize: '18px',
    lineHeight: '100%',
    letterSpacing: '0',
    textAlign: 'center',
    verticalAlign: 'middle',
    margin: '0px',
    textAlign: 'center',
    marginTop: '20px',
  },
  copyLinkCta: {
    width: '100%',
    padding: '15px',
    background: '#1D3557',
    color: '#fff',
    borderRadius: '5px',
    marginTop: '28px',
    textTransform: 'capitalize',
    boxShadow: 'unset !important',
    fontSize: '18px',
    '&:hover': {
      background: '#1D3557',
      boxShadow: 'unset !important',
    },
    '&:active': {
      background: '#16324c',
      transform: 'scale(0.98)',
      boxShadow: 'unset !important',
    },
  },
  addEventCta: {
    width: '100%',
    padding: '15px',
    background: '#51D497',
    color: '#1D3557',
    borderRadius: '5px',
    marginTop: '4px',
    fontSize: '18px',
    textTransform: 'none !important',
    boxShadow: 'unset !important',
    '&:hover': {
      background: '#51D497',
      boxShadow: 'unset !important',
    },
    '&:active': {
      background: '#32b276',
      transform: 'scale(0.98)',
      boxShadow: 'unset !important',
    },
  },
  contactMessage: {
    margin: '0px',
    color: '#666262',
    fontSize: '14px',
    marginTop: '4px !important',
    fontFamily: 'IBM Plex Sans',
    fontWeight: 500,
    lineHeight: 1.3,
    letterSpacing: '0',
    verticalAlign: 'middle',
  },
  onDeskMessage: {
    margin: '0px',
    color: '#000',
    fontSize: '14px',
    marginTop: '15px !important',
    fontFamily: 'IBM Plex Sans',
    fontWeight: 500,
    lineHeight: 1.3,
    letterSpacing: '0',
    verticalAlign: 'middle',
    textAlign: 'left !important',
    marginLeft: '0px !important',
    alignSelf: 'flex-start',
  },
}));

const DesktopAlert = () => {
  const classes = useStyles();

  const copyToClipboard = useCallback(async (text) => {
    try {
      await navigator.clipboard.writeText(window.location.href);
      console.log('Copied:', window.location.href);
    } catch (err) {
      console.error('Failed to copy!', err);
    }
  }, []);

  const addEventToCalendarHandler = useCallback(() => {
    const title = encodeURIComponent(`🚀 Explore Your Quattr Content AI Free Trial`);

    const details = encodeURIComponent(`Hi there 👋,

Your Quattr Content AI trial is ready! 🎉

Dive in to:
✅ <b>Discover Search Intents:</b> Assign keywords based on user intent & create lists for future content.
✅ <b>Create High-Quality Content, Fast:</b> Get competitor insights, content scores as you write, and use Auto Writer for faster production.
✅ <b>Instantly Optimize with GIGA:</b> One-click AI-driven content enhancement for better SEO and structure.

<a href='https://www.quattr.com/login'>Click here</a> to log in and maximize your trial:

Need support? Reach out to us via the chat bubble at the bottom right corner or <a href='https://calendly.com/anuragsinghal/eu'>Schedule a personalized demo.</a>

Thanks
`);
    const location = encodeURIComponent('https://quattr.com');
    const startDate = new Date();
    const endDate = new Date(startDate.getTime() + 60 * 60 * 1000); // +1 hour
    const formatDate = (date) => {
      return date.toISOString().replace(/-|:|\.\d\d\d/g, '');
    };

    let finalDate = startDate;
    let finalEndDate = endDate;
    const currentYear = startDate.getFullYear();
    const currentMonth = startDate.getMonth(); // 0-based index (April = 3)
    const currentDate = startDate.getDate();
    if (currentMonth === 3 && currentDate < 14 && currentYear === 2025) {
      // If it's before 14th April 2025, set to 14th April 2025
      finalDate = new Date(
        currentYear,
        3,
        14,
        startDate.getHours(),
        startDate.getMinutes(),
        startDate.getSeconds(),
        startDate.getMilliseconds()
      );
      finalEndDate = new Date(
        currentYear,
        3,
        14,
        endDate.getHours(),
        endDate.getMinutes(),
        endDate.getSeconds(),
        endDate.getMilliseconds()
      );
    }
    const start = formatDate(finalDate);
    const end = formatDate(finalEndDate);

    const calendarUrl = `https://calendar.google.com/calendar/render?action=TEMPLATE&text=${title}&dates=${start}/${end}&details=${details}&location=${location}&sf=true&output=xml`;
    window.open(calendarUrl, '_blank');
  }, []);

  return (
    <div className={classes.desktopAlertWrapper}>
      <div className={classes.desktopAlertContent}>
        <DesktopAlertSVG />
        <p className={classes.message}>Switch to a desktop for smoother and richer experience!</p>

        <Button variant="contained" color="primary" className={classes.copyLinkCta} onClick={copyToClipboard}>
          Copy Link
        </Button>
        <p className={classes.onDeskMessage}>Not on desk?</p>
        <Button variant="contained" color="primary" className={classes.addEventCta} onClick={addEventToCalendarHandler}>
          Block Time on Calendar
        </Button>
        <p className={classes.contactMessage}>
          We will add an event to your calendar to try Quattr when you are back at your desk.
        </p>
      </div>
    </div>
  );
};

export default DesktopAlert;
